// import { isEmpty } from 'lodash';

import api from '@/api';
// import { baseRequest } from '@/api/request';

import { API_BASE_URL } from '..';

import {
  CreatQuizzesData,
  CreatQuizzesResponse,
  EditQuizzesData,
  ListQuizzesParams,
  ListQuizzesResponse,
  Quiz,
} from './Quizzes.types';

const controller = 'quizzes';
const baseUrl = `${API_BASE_URL}/${controller}`;

export async function listQuizzes(params?: ListQuizzesParams) {
  const result = (await api.get(baseUrl, params)) as unknown;

  return result as ListQuizzesResponse;
}

export async function createQuizzes(data: CreatQuizzesData) {
  const result = (await api.post(baseUrl, data, null)) as unknown;

  return result as CreatQuizzesResponse;
}

export async function detailQuizzes(quizId?: number) {
  const result = (await api.get(`${baseUrl}/${quizId}`, null)) as unknown;

  return result as Quiz;
}

export async function editQuizzes(quizId: number, data: EditQuizzesData) {
  const result = (await api.put(`${baseUrl}/${quizId}`, data, null)) as unknown;

  return result as any; // eslint-disable-line
}

export async function removeQuizzes(quizId: number) {
  const result = (await api.remove(
    `${baseUrl}/${quizId}`,
    {},
    null,
  )) as unknown;

  return result as any; // eslint-disable-line
}
